import './Intro.css';

const Intro = () => {

    return (
        <div className='intro-page'>
            <div className='intro-header'>
                Utahn School for the Deaf and Blind
            </div>
            <div className='intro-yearbook'>
                Yearbooks
            </div>
            <div className='intro-remarks'>
                Sharing and revisiting the memories! Happy delights!
            </div>

        </div>
    );
}

export default Intro;